import { Box, Modal, Typography, useTheme } from '@mui/material'
import React from 'react'
import { CustomeModalButton } from '../../../lib/formik/NewFormInputs'
import { SuccessIcon } from '../../../assets/SvgIcons'

type Props = {
    open: boolean,
    setClose: React.Dispatch<React.SetStateAction<boolean>>
    title: string
    desc: string
    onclick?: () => void,
    confirmBtnText?: string
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '533px',
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    borderRadius: '12px',
    p: '24px',
    ':focus': {
        outline: 'none'
    }
}

function SuccessModal(props: Props) {
    const { open, setClose, title, desc, onclick, confirmBtnText } = props
    const { palette } = useTheme()

    const handleClose = () => {
        onclick ? onclick() : setClose(false)
    }

    return (
        <Modal
            open={open}
            // onClose={() => setClose(false)}
            aria-labelledby={title}
            aria-describedby={'form-modal'}
        >
            <Box
                sx={style}>
                <SuccessIcon style={{ margin: '0 auto', display: 'block' }} />
                <Typography variant='h2' color={palette.text.primary} mt={'12px'} textAlign={'center'}>{title}</Typography>
                <Typography variant='subtitle_400' color={palette.text.secondary} style={{ margin: '10px auto', wordWrap: "break-word" }} mt={'12px'} textAlign={'left'} width={'100%'} maxWidth={'412px'}>{desc}</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', mt: '20px' }}>
                    <CustomeModalButton lookType={'contained'} btnText={confirmBtnText || 'Confirm'} onClick={handleClose} boxStyle={{ borderRadius: '4px' }} />
                </Box>
            </Box>
        </Modal >
    )
}

export default SuccessModal